import React from "react";

import Header from "../../general/Header";
import Aside from "../../general/Aside";
import Footer from "../../general/Footer";
import axios from '../../../axios/axiosconf';
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link, useLocation } from "react-router-dom";
import Loading from "../../general/Loading";

function EditarParametroHistoriaClinica() {

    const queryParams = new URLSearchParams(window.location.search);
    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);
    const search = useLocation().search;
    const id = new URLSearchParams(search).get('id');
    
    const [nombre, setNombre] = useState('');
    const [tipoCampo, setTipoCampo] = useState('checkbox');
    const [errorlist, setErrorlist] = useState({}); // Manejo de errores

    let history = useHistory();

    let userdata = [];

    useEffect(()=>{

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }
        
        axios.get('/get-client', config)
            .then(response => {
                if (response.status===200) {
                    
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log(error);
            });
        
        const config2 = {
            params: {
                id: id
            }
        }

        axios.get('/parametro-historia-clinica',config2)
            .then(response => {
                console.log(response.data[0]);
                const parametro = response.data[0];
                setNombre(parametro.nombre);
                setTipoCampo(parametro.tipo_campo);
            })
            .catch(error => {
                console.log(error);
            });
    },[]);


    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        setErrorlist({});

        const conf = {
            id: id,
            nombre: nombre,
            tipo_campo: tipoCampo
        };
        
        axios.put('/parametro-historia-clinica', conf)
            .then(
                response => {
                    setLoading(false);
                    localStorage.setItem('toastmsg', 'El Parámetro "'+nombre+'" Ha Sido Modificado');
                    history.push('/parametros-historia-clinica');
                }
            )
            .catch(
                err => {
                    console.log(err);
                    setLoading(false);
                    if (err.response?.data?.errors) {
                        setErrorlist(err.response.data.errors);
                    }
                }
            )
    }


    if (loggedIn) {
        return (
            
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="settings" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item" key="bc3"><Link to="/administrar-plantillas">Administrar Plantillas</Link></li>
                                        <li className="breadcrumb-item" key="bc4"><Link to="/parametros-historia-clinica">Parámetros Historia Clínica</Link></li>
                                        <li className="breadcrumb-item" key="bc5">Editar Parámetro Historia Clínica</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Editar Parámetro Historia Clínica</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                            <div className="row">
                            <div className="col-md-10">
                                
                                <div className="card">
                                <div id="infobasica">
                                    <div className="card-body">

                                        <form id="role-form" onSubmit={handleSubmit}>
                                            <div className="row">

                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="nombre">Nombre</label>
                                                        <input type="text" name="nombre" className="form-control" id="nombre" value={nombre} onChange={(e) => setNombre(e.target.value)} />
                                                        {errorlist.nombre && <div className="invalid-feedback d-block">{errorlist.nombre}</div>}
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="tipo_campo">Tipo de Campo</label>
                                                        <select name="tipo_campo" id="tipo_campo" className="form-control" value={tipoCampo} onChange={(e) => setTipoCampo(e.target.value)}>
                                                            <option value="checkbox">Campo de verificación</option>
                                                            <option value="text">Campo de texto</option>
                                                            <option value="textarea">Área de texto</option>
                                                        </select>
                                                        {errorlist.tipo_campo && <div className="invalid-feedback d-block">{errorlist.tipo_campo}</div>}
                                                    </div>
                                                </div>

                                            </div>
                                            <div className="row" style={{marginTop: '30px'}}>
                                                <div className="col-md-6">
                                                    <button type="submit" className="btn btn-primary btn-block">
                                                        Guardar Cambios&nbsp;
                                                        {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null }
                                                        
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                </div>

                            </div>          
                            </div>

                        </div>
                    </section>
                </div>
                <Footer showToast={false} delay={0} />
            </div>
            
        );
    }

    return (
        <Loading />
    );
}
export default EditarParametroHistoriaClinica;